/* eslint-disable global-require */ // The top-level (parent) route
const routes = {
    path: '',
    // Keep in mind, routes are evaluated in order
    children: [
        // static routes (without auth and checking permissions), components use dumpedState (LocalStorage)
        {
            path: '',
            children: [
                {
                    name: 'reports',
                    path: '/reports',
                    load: ()=>import(/* webpackChunkName: 'reports' */ './reports')
                }
            ]
        },
        // with auth
        {
            path: '/mobile',
            children: [
                {
                    name: 'setup-mobile',
                    path: '/setup',
                    load: ()=>import(/* webpackChunkName: 'account' */ './setup-mobile')
                }
            ]
        },
        {
            path: '',
            children: [
                {
                    name: 'setup',
                    path: '/setup',
                    load: ()=>import(/* webpackChunkName: 'account' */ './setup')
                },
                {
                    name: 'clinic-setup',
                    path: '/clinic-setup',
                    load: ()=>import(/* webpackChunkName: 'account' */ './clinic-setup')
                },
                {
                    name: 'google-drive',
                    path: '/google-drive',
                    load: ()=>import(/* webpackChunkName: 'account' */ './google-drive')
                },
                {
                    name: 'account-settings',
                    path: '/account-settings',
                    load: ()=>import(/* webpackChunkName: 'settings' */ './account-settings')
                },
                {
                    name: 'account-settings-view',
                    path: '/account-settings/:view',
                    load: ()=>import(/* webpackChunkName: 'settings' */ './account-settings')
                },
                {
                    name: 'central-storage-auth',
                    path: '/central-storage-auth/:type',
                    load: ()=>import(/* webpackChunkName: 'settings' */ './central-storage-auth')
                }
            ]
        },
        // only for pwd and cg
        {
            path: '/my',
            children: [
                // Patient Results routes have specific isPatientMode param which indicates if it's patient or practitioner view
                {
                    name: 'my-results',
                    path: '',
                    load: ()=>import(/* webpackChunkName: 'pwd-results' */ './my-results')
                },
                {
                    path: '/family',
                    children: [
                        // Patient Results routes have specific isPatientMode param
                        // which indicates if it's patient or practitioner view
                        {
                            name: 'family-member-results',
                            path: '/:patientSlug/:familyLinkId',
                            load: ()=>import(/* webpackChunkName: 'pwd-results' */ './family-member-results')
                        }
                    ]
                }
            ]
        },
        // only for pwd
        {
            path: '/my',
            children: [
                {
                    // Adjusted to alpine mobile view used as webview
                    path: '/mobile',
                    children: [
                        {
                            name: 'mobile-my-doctors',
                            path: '/doctors',
                            load: ()=>import(/* webpackChunkName: 'patient' */ './mobile-my-doctors')
                        },
                        {
                            name: 'mobile-enroll-in-clinic',
                            path: '/enroll-in-clinic',
                            load: ()=>import(/* webpackChunkName: 'patient' */ './mobile-enroll-in-clinic')
                        },
                        {
                            name: 'mobile-my-visits-history',
                            path: '/visits-history',
                            load: ()=>import(/* webpackChunkName: 'visits' */ './mobile-my-visits-history')
                        },
                        {
                            name: 'mobile-visit-notes',
                            path: '/visit-notes/:phisetVisitId',
                            load: ()=>import(/* webpackChunkName: 'visits' */ './mobile-visit-notes')
                        }
                    ]
                }
            ]
        },
        // only for hcp
        {
            path: '/hcp',
            children: [
                {
                    path: '/clinic',
                    children: [
                        {
                            name: 'add-drive',
                            path: '/add-drive',
                            load: ()=>import(/* webpackChunkName: 'clinic-mgmt' */ './add-drive')
                        }
                    ]
                },
                {
                    path: '/:clinicSlug/:organizationUID/clear-data',
                    children: [
                        {
                            name: 'clinic-clear-data',
                            path: '',
                            load: ()=>import(/* webpackChunkName: 'clinic-clear-data' */ './clinic-clear-data')
                        }
                    ]
                },
                {
                    path: '/:clinicSlug/:organizationUID/settings',
                    children: [
                        {
                            name: 'clinic-settings',
                            path: '',
                            load: ()=>import(/* webpackChunkName: 'settings' */ './clinic-settings')
                        },
                        {
                            name: 'clinic-settings-view',
                            path: '/:view',
                            load: ()=>import(/* webpackChunkName: 'settings' */ './clinic-settings')
                        }
                    ]
                },
                {
                    path: '/:clinicSlug/:organizationUID',
                    children: [
                        {
                            name: 'general-population',
                            path: '',
                            load: ()=>import(/* webpackChunkName: 'hcp-stats' */ './general-population')
                        },
                        {
                            name: 'hcp-preview-results',
                            path: '/patient-preview-results',
                            load: ()=>import(/* webpackChunkName: 'hcp-results' */ './preview-results')
                        },
                        // Patient Results routes have specific isPatientMode param
                        // which indicates if it's patient or practitioner view
                        {
                            name: 'hcp-results',
                            path: '/patient/:patientSlug/:patientId',
                            load: ()=>import(/* webpackChunkName: 'hcp-results' */ './hcp-results')
                        },
                        {
                            name: 'patients-list',
                            path: '/patients-list',
                            load: ()=>import(/* webpackChunkName: 'hcp-results' */ './patients-list')
                        },
                        {
                            name: 'medical-patients-list',
                            path: '/medical-patients-list',
                            load: ()=>import(/* webpackChunkName: 'hcp-results' */ './medical-patients-list')
                        }
                    ]
                }
            ]
        },
        // open
        {
            name: 'sign-in',
            path: '',
            load: ()=>import(/* webpackChunkName: 'account' */ './auth')
        },
        {
            name: 'auth',
            path: '/auth',
            load: ()=>import(/* webpackChunkName: 'account' */ './auth')
        },
        {
            name: 'auth-silent',
            path: '/auth-silent',
            load: ()=>import(/* webpackChunkName: 'account' */ './sign-in-silent')
        },
        // TODO: Remove if confirmed
        // {
        //   name: 'data-source-auth',
        //   path: '/data-source-auth',
        //   load: () => import(/* webpackChunkName: 'account' */ './data-source-auth'),
        // },
        {
            name: 'callback-close-webview-mobile',
            path: '/mobile/callback/:rest(.*)?',
            load: ()=>import(/* webpackChunkName: 'account' */ './callback-close-webview-mobile')
        },
        {
            name: 'error',
            path: '/error/:code',
            load: ()=>import(/* webpackChunkName: 'error' */ './error')
        },
        // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
        {
            name: 'not-found',
            path: '(.*)',
            load: ()=>import(/* webpackChunkName: 'not-found' */ './not-found')
        }
    ],
    async action ({ next }) {
        // Execute each child route until one of them return the result
        const route = await next();
        return route;
    }
};
export default routes;
